import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const CareerApplyDialog = ({
  open,
  onClose,
  onSubmit,
  submitting,
  selectedRole,
  formData,
  onFieldChange,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 2.4,
        border: '1px solid rgba(15, 23, 42, 0.12)',
        boxShadow: '0 24px 62px rgba(15, 23, 42, 0.2)',
        overflow: 'hidden',
      },
    }}
  >
    <DialogTitle
      sx={{
        py: 1.3,
        borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
        background: 'linear-gradient(180deg, #F3F9FF 0%, #FFFFFF 100%)',
        fontWeight: 780,
        color: '#0B3A67',
      }}
    >
      Apply for {selectedRole?.title || 'This Role'}
    </DialogTitle>
    <DialogContent sx={{ pt: 1.4, background: '#FFFFFF' }}>
      <Stack spacing={1.1}>
        {selectedRole?.department ? (
          <Typography sx={{ fontSize: '0.78rem', color: 'rgba(15,23,42,0.7)', fontWeight: 600 }}>
            Department: {selectedRole.department}
          </Typography>
        ) : null}
        <Grid container spacing={1.1}>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              fullWidth
              label="First Name"
              value={formData.firstName}
              onChange={(event) => onFieldChange('firstName', event.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              fullWidth
              label="Last Name"
              value={formData.lastName}
              onChange={(event) => onFieldChange('lastName', event.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              fullWidth
              label="Email"
              type="email"
              value={formData.email}
              onChange={(event) => onFieldChange('email', event.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              fullWidth
              label="Phone"
              value={formData.phone}
              onChange={(event) => onFieldChange('phone', event.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              fullWidth
              label="Experience (Years)"
              value={formData.yearsExperience}
              onChange={(event) => onFieldChange('yearsExperience', event.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              fullWidth
              label="Portfolio/Resume URL"
              value={formData.portfolioUrl}
              onChange={(event) => onFieldChange('portfolioUrl', event.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              multiline
              minRows={4}
              label="Message"
              value={formData.message}
              onChange={(event) => onFieldChange('message', event.target.value)}
            />
          </Grid>
        </Grid>
      </Stack>
    </DialogContent>
    <DialogActions
      sx={{
        px: 2,
        py: 1.1,
        borderTop: '1px solid rgba(15, 23, 42, 0.08)',
        background: '#FFFFFF',
      }}
    >
      <Button variant="outlined" onClick={onClose} disabled={submitting}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={submitting}
        sx={{
          background: 'linear-gradient(90deg, #0B3A67 0%, #1D4ED8 100%)',
        }}
      >
        {submitting ? <CircularProgress size={18} color="inherit" /> : 'Submit Application'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CareerApplyDialog;
